<script
  lang="ts"
  setup
  generic="T extends Record<string, any> & { icon?: string; label?: string; key: string; }"
>

const props = withDefaults(defineProps<{
  modelValue?: string,
  headerClass?: string,
  headerColor?: "gray" | "white",
  highlightColor?: string,
  tabPosition?: "left" | "right",
  tabIconClass?: string,
  tabClass?: string,
  tabListClass?: string,
  tabContainerClass?: string,
  maxTabs?: number,
  tabs?: T[]
}>(), {
  tabs: () => [],
  tabPosition: "left",
  headerColor: "gray",
  tabIconClass: "",
  tabListClass: "",
  tabContainerClass: "",
  headerClass: ""
});

const emit = defineEmits<{
  'update:modelValue': (value: string) => void;
}>();

</script>

<template>

  <div
    class="
      relative bg-white dark:[&[role='button']]:!bg-gray-950 dark:bg-gray-900
      border border-gray-300/70 dark:border-gray-700/60
      rounded-[4px] sm:shadow-sm shadow-none
      "
    :class="[
      tabs?.length ? `${tabPosition === 'left' ? 'rounded-tl-none' : 'rounded-tr-none'} mt-[32px]` : '',
      maxTabs === tabs.length ? '!rounded-tr-none' : '',
    ]"
    :style="highlightColor ? { borderColor: highlightColor, boxShadow: `0 0 0 1px ${highlightColor}` } : undefined">

    <div
      v-if="tabs?.length"
      class="flex w-full items-end absolute bottom-full space-x-1 -mt-px z-10"
      :class="[
        tabListClass,
        tabPosition === 'left' ? 'justify-start -left-px' : 'justify-end -right-px',
      ]">

      <slot
        v-for="(tab, index) in tabs"
        name="tab">

        <div
          class="relative"
          :class="tabContainerClass">

          <slot name="tab-above" />

          <GenericPanelTab
            :key="tab.key"
            :tab-key="tab.key"
            :highlight-color="highlightColor"
            :icon="tab.icon"
            :label="tab.label"
            :active="modelValue === tab.key"
            :class="tabClass"
            :icon-class="tabIconClass"
            @click="emit('update:modelValue', tab.key)" >

            <slot
              name="tab-content"
              :tab="tab"
              :index="index"
              :visible="modelValue === tab.key" />

          </GenericPanelTab>


        </div>

      </slot>


    </div>

    <div
      v-if="$slots.header"
      :class="[
        headerColor === 'gray' ? 'bg-gray-50 dark:bg-gray-900' : 'bg-white dark:bg-gray-900',
        headerClass,
      ]"
      class="
      px-2 py-2.5">
      <slot name="header" />
    </div>

    <slot />

  </div>
</template>
